import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { Switch, BrowserRouter as Router, useLocation } from "react-router-dom"
import { connect } from "react-redux"
import io from "socket.io-client"
import { isMobile } from "react-device-detect"
import DeviceOrientation, { Orientation } from "react-screen-orientation"
import { Container } from "reactstrap"

// Import Routes all
import { userRoutes, authRoutes } from "./routes/allRoutes"

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware"

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

// Import scss
import "./assets/scss/theme.scss"

import Page from "pages"
import Notifications from "pages/UIcomponents/Notification"
import { onMessageListener } from "./firebaseInit"
import FirebaseNotifications from "pages/notifications/firebaseNotification"
import AddToHomeScreenPrompt from "components/AddToHome"

const Alldata = JSON.parse(localStorage.getItem("dataJ"))

// ─── Orientation Guard ───────────────────────────────────────────────────────
// Must be rendered inside <Router> so that useLocation works without a refresh.
const OrientationGuard = ({ children }) => {
  const location = useLocation()
  const currentPath = location.pathname

  const isLoginRoute = currentPath === "/login"
  const isRegisterRoute = currentPath === "/regiister"
  const isRootRoute = currentPath === "/"
  const skipOrientationLock = isLoginRoute || isRegisterRoute || isRootRoute

  // Desktop or exempt routes — render children as-is
  if (!isMobile || skipOrientationLock) {
    return <>{children}</>
  }

  // Mobile + protected routes — enforce landscape
  return (
    <DeviceOrientation lockOrientation={"landscape"}>
      <Orientation orientation="landscape" alwaysRender={false}>
        {children}
      </Orientation>
      <Orientation orientation="portrait" alwaysRender={false}>
        <Container style={{ padding: 0, position: "relative" }} fluid>
          <img
            loading="lazy"
            width="100%"
            height="100%"
            alt="Rotate your phone"
            src="https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/apple%20virtual%20platform%2FRotate%20Your%20Phone.gif?alt=media&token=797900cb-990e-466a-9182-c675914732ab"
            style={{
              zIndex: 9999999999999999999,
              position: "fixed",
              display: "block",
              backgroundColor: "white",
            }}
          />
        </Container>
      </Orientation>
    </DeviceOrientation>
  )
}

OrientationGuard.propTypes = {
  children: PropTypes.node,
}
// ─────────────────────────────────────────────────────────────────────────────

const App = props => {
  const [show, setShow] = useState(false)
  const [notification, setNotification] = useState({ title: "", body: "" })

  onMessageListener()
    .then(payload => {
      setNotification({
        title: payload.notification.title,
        body: payload.notification.body,
      })
      setShow(true)
      console.log("payload", payload)
    })
    .catch(err => console.log("failed: ", err))

  function getLayout() {
    let layoutCls = VerticalLayout
    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout
        break
      default:
        layoutCls = VerticalLayout
        break
    }
    return layoutCls
  }

  useEffect(() => {
    const socket = io.connect(process.env.REACT_APP_ADMIN)

    socket.on("notificationChannel", message => {
      const { redirect } = message

      if (message?.redirect !== null && message?.redirect !== "") {
        window.location.href = message?.redirect
        return
      }
    })

    return () => socket.disconnect()
  }, [])

  const Layout = getLayout()

  return (
    <React.Fragment>
      {show ? (
        <Notifications
          toastType="success"
          title={notification.title}
          body={notification.body}
        />
      ) : (
        <></>
      )}

      <Router>
        {/* OrientationGuard must be inside <Router> to use useLocation */}
        <OrientationGuard>
          <Switch>
            {Alldata
              ? authRoutes.map((route, idx) => (
                  <Authmiddleware
                    path={route.path}
                    layout={NonAuthLayout}
                    objct={route.objct}
                    component={route.component}
                    key={idx}
                    isAuthProtected={false}
                    exact
                  />
                ))
              : location.reload()}

            {Alldata
              ? userRoutes.map((route, idx) => (
                  <Authmiddleware
                    path={route.path}
                    layout={Layout}
                    objct={route.objct}
                    component={route.component}
                    key={idx}
                    isAuthProtected={true}
                    exact
                  />
                ))
              : location.reload()}

            {Alldata
              ? Object.keys(Alldata.data).map((route, idx) => (
                  <Authmiddleware
                    path={"/page/" + route}
                    layout={Layout}
                    objct={Alldata.data[route]}
                    component={Page}
                    key={idx}
                    isAuthProtected={true}
                    exact
                  />
                ))
              : location.reload()}
          </Switch>
        </OrientationGuard>
      </Router>

      <FirebaseNotifications />
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

export default connect(mapStateToProps, null)(App)